import type { DocumentsUploadFieldProps } from "./documents-upload-field.type";

import { useTranslation } from "react-i18next";

import UploadFile from "@/modules/upload-file";
import UploadFormItem from "@/modules/upload-form-item";

import { convertDocumentsToUploadExistingFiles } from "./documents-upload-field.helper";

const DocumentsUploadField = ({
  documents,
  uploadProps,
  ...fieldProps
}: DocumentsUploadFieldProps) => {
  const { t } = useTranslation();

  const defaultFileList = convertDocumentsToUploadExistingFiles(documents);

  return (
    <UploadFormItem
      name="documents"
      label={t("global:documentPlural")}
      {...fieldProps}
    >
      <UploadFile {...uploadProps} multiple defaultFileList={defaultFileList} />
    </UploadFormItem>
  );
};

export default DocumentsUploadField;
